import { useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import GenerateReport from './GenerateReport';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../components/helpers/Translator';
import AppModal from '../../../components/Modal/AppModal';
import useIsMounted from '../../../components/hooks/useIsMounted';
import _ from 'lodash';

const GenerateProfileReport = (props) => {
  const { moduleBridgeHex, values, onFinish } = props;
  const isMounted = useIsMounted();
  const [pendingProfiles, setPendingProfiles] = useState(values.profiles);
  const [nextProfile, setNextProfile] = useState(null);
  const [generalModalInfo, setGeneralModalInfo] = useState({
    percent: 1,
    message: ReactDOMServer.renderToString(
      <Translator file="module-intelligence" name="preparing.information" />
    ),
  });
  const [reportModalInfo, setReportModalInfo] = useState({
    percent: 0,
    message: '-',
  });
  useEffect(() => {
    if (pendingProfiles.length > 0) {
      setGeneralModalInfo({
        percent:
          5 +
          (95 / values.profiles.length) *
            (values.profiles.length - pendingProfiles.length),
        message: `${ReactDOMServer.renderToString(
          <Translator file="module-intelligence" name="creating.report" />
        )} ${values.profiles.length - pendingProfiles.length + 1}/${
          values.profiles.length
        }`,
      });
      setNextProfile(pendingProfiles[0]);
    } else onFinish();
  }, [pendingProfiles]);

  const handleReportInfo = (info) => {
    setReportModalInfo(info);
  };

  const handleRemoveFirstElement = (values) => {
    let shiftedPendingProfiles = _.cloneDeep(pendingProfiles);
    shiftedPendingProfiles.shift();
    setPendingProfiles(shiftedPendingProfiles);
    setNextProfile(null);
  };

  return (
    <>
      <AppModal
        size={'lg'}
        show
        isCloseButton={false}
        title={ReactDOMServer.renderToString(
          <Translator file="module-intelligence" name="creating.reports" />,
        )}
      >
        <p>
          <Translator file="module-intelligence" name="can.take.minutes" />
        </p>
        <h2>{generalModalInfo.message}</h2>
        <ProgressBar
          variant={'success'}
          animated
          now={generalModalInfo.percent}
        />
        <h4>{reportModalInfo.message}</h4>
        <ProgressBar animated now={reportModalInfo.percent} />
      </AppModal>
      {nextProfile && (
        <GenerateReport
          moduleBridgeHex={moduleBridgeHex}
          values={nextProfile}
          onFinish={handleRemoveFirstElement}
          getModalInfo={handleReportInfo}
          comment={values.comment}
        />
      )}
    </>
  );
};

export default GenerateProfileReport;
